import { render, staticRenderFns } from "./GraficoEdadComponent.vue?vue&type=template&id=0e45580c"
import script from "./GraficoEdadComponent.vue?vue&type=script&lang=js"
export * from "./GraficoEdadComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports